import * as React from 'react';
import { Input, EVisualSize } from '@cian/ui-kit/prev';
import { mergeStyles } from '@cian/utils';
import { Field } from 'formik';
import { useFieldHasErrors } from './utils';
import { Label } from './Label';
import * as styles from '../index.css';

export const Name = () => {
  const invalid = useFieldHasErrors('name');

  return (
    <div {...mergeStyles(styles['field'], styles['span-columns'])}>
      <Label invalid={invalid}>Ваше имя</Label>
      <Field name="name" as={Input} custom={{ invalid, size: EVisualSize.DESKTOP }} />
    </div>
  );
};
